// ** React Imports
import { Fragment } from "react";

// ** Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Utils & Helpers
import generateQueryPath from "utils/generateQueryPath";

// ** Custom Components
import Block from "components/layout/Block";
import Text from "components/typography/Text";
import Link from "components/layout/Link";

// ** Custom Hooks
import { compute as interestCompute } from "hooks/filters/useFilterInterests";

// ** Routes
import { initialQuery } from "containers/Users/initialQuery";

// #####################################################

const DataInterests = () => {
	const { t } = useTranslation(["filtersAndSelectors"]);

	const userInterests = useSelector(
		(state) => state.userProfileMain.interests
	);

	// #####################################################

	return userInterests.length !== 0 ? (
		<Block>
			<Text>{t("filtersAndSelectors:interestLabel")}:</Text>{" "}
			{userInterests
				.filter((item) => item !== null)
				.sort((a, b) => {
					return t(
						`filtersAndSelectors:interests.${a}`
					).localeCompare(
						t(`filtersAndSelectors:interests.${b}`),
						undefined,
						{
							numeric: false,
							sensitivity: "base",
						}
					);
				})
				.map((item, index) => {
					const to = generateQueryPath(`/search`, {
						...initialQuery,
						interests: interestCompute.valueToQueryUrl(item),
					});

					return (
						<Fragment key={`item-${item}`}>
							<Link to={to} underline color="primary" bold>
								{t(`filtersAndSelectors:interests.${item}`)}
							</Link>
							{userInterests[index + 1] && ", "}
						</Fragment>
					);
				})}
		</Block>
	) : null;
};

// #####################################################

export default DataInterests;

// #####################################################
